import React, { useEffect,useState } from "react";
import { useLocation } from "react-router-dom";
import img from "./Img/nailtibiarender.webp";
import nail from "./Img/monail.png";
import TableComponent from "./TableComponent";
import NailFeature from "./NailFeature";
import NailPoints from "./NailPoints";
import NailPara from "./NailPara";

function Ortho() {
  // Create a ref to the top of the Ortho component
  
  const location = useLocation();
   const [isLargeScreen, setIsLargeScreen] = useState(() =>
              window.matchMedia("(min-width: 1280px)").matches
            );
             useEffect(() => {
                const mediaQuery = window.matchMedia("(min-width: 1280px)");
                const handleChange = (e) => setIsLargeScreen(e.matches);
                mediaQuery.addEventListener("change", handleChange);
            
                return () => {
                  mediaQuery.removeEventListener("change", handleChange);
                };
              }, []);

  // Scroll to the top when the component is mounted
  //Empty dependency array means this runs only once after the component mounts
 useEffect(() => {
     window.scrollTo(0, 0); // Scroll to top of the page
   }, [location.pathname]);
  return (
    <>
      {/* The ref is placed on the first element of the Ortho component */}
      {isLargeScreen&&
      <div className="d-flex position-relative flex-column m-0 p-0 uh-130 w-100 justify-content-end" style={{ overflow: "hidden" }}>
        {/* Image */}
        <div
          className="uh-130 m-0 p-0 w-100"
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>
        <div className="position-absolute upx-20 uh-50 upt-23 upb-17 uw-130">
          {/* Content inside the right-side div */}
          <p className="m-0 p-0 ufs-11 fw-bold text-gray">Intramedullary Lengthening Nail</p>
          <p className="m-0 p-0 ufs-4 fw-bold text-gray">COMPLETE INTERNAL LENGTHENING  </p>
          <p className="m-0 p-0 ufs-4 fw-bold text-gray"> FROM 9MM DIAMETER AND ABOVE</p>
        </div>
      </div>}
      {!isLargeScreen&&
      <div
      className="d-flex position-relative d-flex flex-column m-0 p-0  w-100 justify-content-end"
      style={{
      overflow: "hidden",
      }}
      >
      
      {/* Image */}
      <div
      className=" m-0 p-0 w-100"
      style={{
          backgroundImage: `url(${nail})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: '90vh'
      }}
      ></div>
      <div
          className="  position-absolute upx-20 uh-160 upy-20 w-100 bottom-25 top-75  " // Positioned to the top-right corner of the parent div
      >
          {/* Content inside the right-side div */}
          <p className=" m-0 p-0 ufs-14 fw-bold text-gray">Intramedullary Lengthening Nail</p>
          <p className=" m-0 p-0 ufs-11 fw-bold  text-gray">Complete internal Lengthening </p>
          <p className=" m-0 p-0 ufs-11 fw-bold  text-gray">From 9mm Diameter And Above </p>
          
          <div className="m-0 d-flex upt-2 text-center uh-50">
        
      </div>
      </div>
      </div>
      }
      <NailFeature/>
      <NailPara/>
      <NailPoints/>
      <TableComponent />
      
    </>
  );
}

export default Ortho;
